import request from 'umi-request';
import { errorHandler, iRequest } from '../../utils/requestutil';

// export async function query() {
//   return iRequest(`/iwms-openapi/api/v2/api-docs`);
// }

export async function query(payload) {
  return iRequest(`/iwms-openapi/api/menu?interfaceType=${payload}`);
}

export async function queryAllMenus(payload) {
  return iRequest(`/iwms-openapi/api/menu/queryAllMenus`);
}

export async function sendQuest(payload) {
  let option = {};
  if (payload.parameters) {
    option = {
      method: payload.type,
      data: payload.parameters,
      headers: {
        iwmsApiKey: payload.headers,
      },
    };
  } else {
    option = {
      method: payload.type,
      headers: {
        iwmsApiKey: payload.headers,
      },
    };
  }

  return request(payload.url, {
    ...option,
  })
    .then(function({ data, response, success, message }) {
      const result = { data, response, success, message };
      return result;
    })
    .catch(function(error) {
      return errorHandler(error);
    });
}

export async function copydc(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/copydc?companyUuid=${window.sessionStorage.getItem(
      'companyUuid',
    )}&dcCode=${payload.dcCode}&menuName=${payload.menuName}&sourceDcCode=${
      payload.sourceDcCode
    }`,
    {
      method: 'POST',
    },
  );
}

export async function copyowner(payload) {
  let sourceErpUuid = payload.sourceErpUuid ? payload.sourceErpUuid : '';
  let targetErpUuid = payload.targetErpUuid ? payload.targetErpUuid : '';

  return iRequest(
    `/iwms-openapi/api/interfaceConfig/copyowner?companyUuid=${window.sessionStorage.getItem(
      'companyUuid',
    )}&sourceErpUuid=${sourceErpUuid}&targetErpUuid=${targetErpUuid}&menuName=${
      payload.menuName
    }&ownerCode=${payload.ownerCode}&sourceOwnerCode=${
      payload.sourceOwnerCode
    }`,
    {
      method: 'POST',
    },
  );
}

export async function exportApi(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/export?companyUuid=${window.sessionStorage.getItem(
      'companyUuid',
    )}&dcCode=${payload.dcCode}&interfaceUuid=${
      payload.interfaceUuid
    }&menuName=${payload.menuName}&ownerCode=${payload.ownerCode}`,
    {
      method: 'POST',
      body: payload.uuids,
    },
  );
}

export async function importApi(payload) {
  let dcCode = payload.dcCode ? payload.dcCode : '';
  let erpUuid = payload.erpUuid ? payload.erpUuid : '';
  let dingDingUuid = payload.dingDingUuid ? payload.dingDingUuid : '';
  let ownerCode = payload.ownerCode ? payload.ownerCode : '';
  let serviceBaseUrl = payload.serviceBaseUrl ? payload.serviceBaseUrl : '';
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/import?companyUuid=${window.sessionStorage.getItem(
      'companyUuid',
    )}&dcCode=${dcCode}&erpUuid=${erpUuid}&dingDingUuid=${dingDingUuid}&ownerCode=${ownerCode}&serviceBaseUrl=${serviceBaseUrl}`,
    {
      method: 'POST',
      body: JSON.parse(payload.jsonData),
    },
  );
}
